import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import { Box, Heading, Center, Image, Text } from '@chakra-ui/react';

import ScrollToDown from '@/components/Common/ScrollToDown/V1';
import WithAnimation from '@/components/Common/WithAnimation';
import CopyRight from '@/components/Section/CopyRight';

import playMusic from '@/components/Common/FloatingMusic/utils/playMusic';
import useInvitation from '@/hooks/useInvitation';
import useSPH from '@hooks/useSPH';

import { DEFAULT_LANGUAGE as lang } from '@/constants/feature-flags';
import { BG_SECONDARY } from '@/constants/colors';
import { SPH_LOGO } from '@/constants/sph';

import txtWording from './locales';

/**
 * Function to render Component CoverV3
 * This component will be dissapear after user click show `Undangan`
 * @return {JSX.Element}
 */
function Cover({ onSeeDetail }) {
  const [loading, setLoading] = useState(false);
  const [bg, setBg] = useState('');
  const [showTitle, setShowTitle] = useState(false);
  const invitation = useInvitation();
  const sph = useSPH();

  const handleClickDetail = () => {
    if (loading) return undefined;

    playMusic();

    setLoading(true);
    setTimeout(() => {
      onSeeDetail();
      setLoading(false);
    }, 1500);
  };

  useEffect(() => {
    setShowTitle(true);
    setBg(sph.imgCover);
  }, [invitation]);

  return (
    <Box minHeight="100vh" backgroundColor={BG_SECONDARY} pos="relative">
      <Box
        height="89vh"
        bgImage={`url(${bg})`}
        bgSize="cover"
        bgPos="center"
        pos="relative"
        width="100%"
      >
        <Box bgColor="blackAlpha.500" height="89vh">
          <Box display="block">
            {showTitle && (
              <Box position="absolute" width="100%" top="42px">
                {invitation && (
                  <Center padding="0 0 8px 0" paddingTop="3rem">
                    <Image src={SPH_LOGO} height="90px" />
                  </Center>
                )}
                <WithAnimation>
                  <Heading
                    textAlign="center"
                    fontWeight="normal"
                    fontSize="2xl"
                    fontFamily="body"
                    marginTop="16px"
                    color="white"
                  >
                    {sph.title}
                  </Heading>
                </WithAnimation>
                <WithAnimation>
                  <Text
                    textAlign="center"
                    fontWeight="normal"
                    fontSize="4xl"
                    fontFamily="body"
                    color="white"
                  >
                    {sph.desc}
                  </Text>
                </WithAnimation>
                <WithAnimation>
                  <Text
                    textAlign="center"
                    fontWeight="normal"
                    fontSize="2xl"
                    fontFamily="body"
                    color="white"
                  >
                    {sph.date}
                  </Text>
                </WithAnimation>
              </Box>
            )}
            <Box position="absolute" display="block" width="100%" bottom="62px">
              <ScrollToDown
                text={txtWording.open[lang]}
                onClick={handleClickDetail}
                loading={loading}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <CopyRight
        withWave
        withSong={false}
        withFlatIcon={false}
        transformWave="translateY(-38px)"
        transformBody="translateY(-40px)"
        fontSize="small"
        padding="16px 16px 8px 16px"
      />
    </Box>
  );
}

Cover.propTypes = {
  onSeeDetail: func.isRequired,
};

export default Cover;
